// extracted by mini-css-extract-plugin
module.exports = {"framework-selector":"L_b9 d-flex","framework-selector__icon":"L_cb","framework-selector__option":"L_cc p-2 flex-grow-1 ml-2","framework-selector__option--selected":"L_cd"};